import { Link } from "react-router-dom";
import { formatDate, formatViews } from "@/lib/articles";
import type { Article } from "@/mocks/articles";

interface ArticleCardProps {
  article: Article;
  showCategory?: boolean;
}

export default function ArticleCard({ article, showCategory = true }: ArticleCardProps) {
  return (
    <article className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-200 hover:bg-primary-50/40 md:gap-5 md:p-4">
      <Link
        to={`/detail/${article.id}`}
        className="relative h-24 w-32 shrink-0 overflow-hidden rounded-md md:h-28 md:w-44"
        aria-label={article.title}
      >
        <img
          src={article.cover}
          alt={article.title}
          title={`${article.title} - 蜜桃33`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </Link>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
          {showCategory && (
            <Link
              to={`/category/${article.category}`}
              className="rounded-full bg-secondary-100 px-2.5 py-1 font-medium text-secondary-900 transition-colors hover:bg-secondary-200"
            >
              {article.categoryName}
            </Link>
          )}
          <span className="whitespace-nowrap">{formatDate(article.publishedAt)}</span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-eye-line text-sm" />
            {formatViews(article.views)}
          </span>
        </div>
        <h3 className="mt-2 text-base font-semibold leading-snug text-foreground-950 md:text-lg">
          <Link to={`/detail/${article.id}`} className="link-underline">
            {article.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {article.summary}
        </p>
      </div>
    </article>
  );
}